import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { NAVICA, NAV_ITEMS } from "@/lib/constants";
import { NavicaMark } from "@/components/brand/NavicaBrand";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md bg-[#FAF1E4]/85 border-b border-[#F0E5DE]"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group shrink-0" data-testid="logo-link">
          <NavicaMark size={40} className="shrink-0 transition-transform group-hover:scale-105 group-hover:rotate-3" />
          <div className="leading-tight">
            <div className="font-display text-2xl lg:text-[26px] font-semibold tracking-tight" style={{ color: "var(--navica-navy)" }}>
              NAVICA
            </div>
            <div className="text-[10px] lg:text-[11px] tracking-[0.22em] uppercase italic -mt-0.5" style={{ color: "var(--navica-coral)" }}>
              supports
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-5 xl:gap-7" data-testid="desktop-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `nav-link text-sm font-medium tracking-wide ${isActive ? "active" : "text-[#284952]"}`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3 shrink-0">
          <a
            href={`tel:${NAVICA.phoneRaw}`}
            className="flex items-center gap-2 text-sm font-medium text-[#284952] hover:text-[#E2718A] transition-colors"
            data-testid="navbar-phone"
          >
            <Phone className="w-4 h-4" />
            {NAVICA.phone}
          </a>
          <Link to="/referrals" className="btn-primary text-sm" data-testid="navbar-refer-cta">
            Make a Referral
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 rounded-lg hover:bg-[#F8E8E2]"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FAF1E4] border-t border-[#F0E5DE]" data-testid="mobile-menu">
          <div className="px-5 py-6 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-base font-medium transition ${
                    isActive ? "bg-[#F8E8E2] text-[#E2718A]" : "text-[#284952] hover:bg-[#F1E4D5]"
                  }`
                }
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </NavLink>
            ))}
            <div className="flex flex-col gap-3 mt-4 pt-4 border-t border-[#F0E5DE]">
              <a href={`tel:${NAVICA.phoneRaw}`} className="flex items-center gap-2 px-4 text-sm font-medium text-[#284952]">
                <Phone className="w-4 h-4" /> {NAVICA.phone}
              </a>
              <Link to="/referrals" onClick={() => setOpen(false)} className="btn-primary text-sm mx-4">
                Make a Referral
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
